import { marketingAttributionEvent } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const performanceRowSchema = z.object({
  KEY: z.string(),
  NAME: z.string(),
  CHANNEL: z.string(),
  REVENUE: z.number(),
  SPEND: z.number(),
  ROI: z.number(),
  REVENUE_PER_RECIPIENT: z.number(),
  UNIQUE_RECIPIENTS: z.number(),
  TOTAL_ORDERS: z.number(),
  TOTAL_CLICKS: z.number(),
  TOTAL_OPENS: z.number(),
  TOTAL_SENDS: z.number(),
  SENT_DATE: z.date().nullable(),
});

const automationPerformanceTotalsSchema = z.object({
  totalRevenue: z.number(),
  totalSpend: z.number(),
  totalROI: z.number(),
  totalRecipients: z.number(),
  totalOrders: z.number(),
  // Comparison data for previous period
  previousTotalRevenue: z.number(),
  previousTotalSpend: z.number(),
  previousTotalROI: z.number(),
  previousTotalRecipients: z.number(),
  previousTotalOrders: z.number(),
});

export const getAutomationPerformanceAnalytics = {
  name: "getAutomationPerformanceAnalytics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    attributionDays: z.number().min(1).max(30).optional().default(5),
    channels: z.array(z.enum(["email", "sms"])).optional(),
    attributionEvents: z
      .array(z.enum(Object.values(marketingAttributionEvent)))
      .optional(),
  }),
  output: z.object({
    automations: z.array(performanceRowSchema),
    totals: automationPerformanceTotalsSchema,
  }),
};
